import React, {
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react"
import { GlobalStateContext } from "../../../context/GlobalContextProvider"
import CustomPagination from "../../common/customPagination/customPagination"
import { Title } from "../../product-detail/itemDescription/styles"
import ItemCard from "../ItemCard/ItemCard"
import "./cardslist.scss"

const CardsList = (props) => {
  const {
    withoutFilter,
    courses,
    withSearchList,
    hasActiveFilters,
  } = props
  const [activePage, setactivePage] = useState(1)
  const [totalRecordCount, settotalRecordCount] =
    useState(10)
  const itemsCount = 8
  const [resultCourses, setresultCourses] = useState(null)

  const state =
    useContext(GlobalStateContext) || {}
  const { searchResultsCourses, filteredCoursesList } = state
  const setResults = useCallback(() => {
    const fromIndex =
      activePage === 1
        ? activePage - 1
        : (activePage - 1) * itemsCount

    const toIndex =
      activePage === 1 ? itemsCount : fromIndex + itemsCount

    const sortcourses = courses && courses.sort((a, b) => {
      if (a.category && a.category.includes('featured')) {
        return -1
      }
      return 1
    })

    const allCoursesList = hasActiveFilters
      ? filteredCoursesList
      : withSearchList
        ? searchResultsCourses
        : sortcourses
    const coursesToShow = allCoursesList.slice(
      fromIndex,
      toIndex
    )
    setresultCourses(coursesToShow)
  }, [
    activePage,
    courses,
    filteredCoursesList,
    hasActiveFilters,
    searchResultsCourses,
    withSearchList,
  ])

  const setCourses = useCallback(() => {
    setResults()
    settotalRecordCount(
      hasActiveFilters
        ? filteredCoursesList.length
        : withSearchList
          ? searchResultsCourses.length
          : courses.length
    )
  }, [
    setResults,
    withSearchList,
    searchResultsCourses?.length,
    hasActiveFilters,
    filteredCoursesList?.length,
    courses.length,
  ])

  useEffect(() => {
    setCourses()
    return () => {
      setresultCourses([])
    }
  }, [
    searchResultsCourses,
    setCourses,
    withSearchList,
    filteredCoursesList,
  ])

  const handlePageChange = (pageNumber) => {
    setactivePage(pageNumber)
    setResults()
  }

  return (
    <div
      className={`filterredCoursesContainer ${withoutFilter && "allcoursesContainer"
        }`}
    >
      <div>
        {withoutFilter ? (
          <Title>Courses</Title>
        ) : (
          <span className="results">
            showing{" "}
            <p>
              {hasActiveFilters
                ? filteredCoursesList.length
                : withSearchList
                  ? searchResultsCourses.length
                  : courses.length}
            </p>{" "}
            results
          </span>
        )}
        <div className="filteredList">
          {resultCourses
            ? resultCourses.map((course) => (
                <ItemCard
                  key={course.id}
                  slug={course.slug}
                  coverPhoto={course.coverPhoto}
                  title={course.title}
                  category={course.category}
                  courseReference={course.courseReference}
                  netFee={
                    course.product?.netFee ||
                    course.product?.price
                  }
                  duration={course.duration}
                  trainingMode={
                    course.trainingMode || "Classroom"
                  }
                  courseRuns={course.courseRuns}
                />
              ))
            : null}
        </div>
      </div>

      <div className="pagination-main-coltainer">
        <CustomPagination
          handlePageChange={handlePageChange}
          activePage={activePage}
          Total={totalRecordCount}
          itemsCount={itemsCount}
        />
      </div>
    </div>
  )
}

export default CardsList
